import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const GlobalButton = ({
  variant,
  handleClickBtn,
  endIcon,
  startIcon,
  disabled,
  hoverProperties,
  iconHoverColor,
  btnText,
  disableRipple,
  styleProps,
  size = "small",
}) => {
  const { t } = useTranslation(["common"])
  return (
    <Button
      disableRipple={false || disableRipple}
      variant={variant || "contained"}
      onClick={handleClickBtn}
      endIcon={endIcon}
      startIcon={startIcon}
      disabled={disabled}
      size={size || "small"}
      sx={{
        ...styleProps,
        "&:hover": {
          ...hoverProperties,
        },
        "&.MuiButtonBase-root:hover .MuiButton-startIcon svg": {
          color: iconHoverColor,
        },
        "&.MuiButtonBase-root:hover .MuiButton-endIcon svg": {
          color: iconHoverColor,
        },
      }}
    >
      {t(btnText, { ns: "common" })}
    </Button>
  );
};

export default GlobalButton;
